// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-nocheck
import React from 'react';
import { Link } from 'react-router-dom';

interface PanelContentBreadcrumbProps {
  items: Array<{
    active: boolean;
    title: string;
    url?: string;
    state?: unknown;
  }>;
}

const PanelContentBreadcrumb = ({ items }: PanelContentBreadcrumbProps) => (
  <div className="panel-content-breadcrumb">
    <ul className="panel-content-breadcrumb__menu">
      {items.map((item, itemIndex) => (
        <li
          className="panel-content-breadcrumb__menu__item"
          key={itemIndex.toString()}
        >
          {item.url ? (
            <Link
              className={`panel-content-breadcrumb__menu__item__link ${
                item.active
                  ? 'panel-content-breadcrumb__menu__item__link--active'
                  : ''
              }`}
              to={{
                pathname: item.active && item.url ? item.url : '',
                state: item.state ?? undefined,
              }}
            >
              {item.title}
            </Link>
          ) : (
            <span className="panel-content-breadcrumb__menu__item__link">
              {item.title}
            </span>
          )}
        </li>
      ))}
    </ul>
  </div>
);

export default PanelContentBreadcrumb;
